<template>
	<modal class="ui ui--keypad" role="dialog">
		<ElementHeadlineBig aria-hidden="true" content="keyPadStationNumber" i18n />
		<ElementInputtext
			ref="keypadInput"
			name="Enter Number"
			type="numeric"
			inputmode="numeric"
			pattern="\d*"
			:placeholder="placeHolderText"
			maxlength="9"
			autoExpand
			v-model.number="code"
			@keyup="processInput"
		/>

		<ElementButton ref="Ok" name="send" @click="send" content="OK" tabindex="0" />
		<ElementButton ref="close" name="close" @click="closeAndResetFocus" content="close" i18n tabindex="0" />
	</modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import UiBase from './base.vue';
import { uiComponents } from '../../tools/viewState';
import errorHandler from '@/tools/errorHandler';
import { actionTypes, errorTypes, getterTypes } from '../../types';
import { i18n } from '@/tools/i18n';
// Use `type="numeric"` since this gives the smallest keypad on mobile operating systems
// FireFox does not support this input type yet. Also Desktop browsers allow letter input.

export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.uiKeypad,
			code: '',
		};
	},
	computed: {
		...mapState(['viewState']),
		placeHolderText() {
			return i18n.t('keyPadEnterNumber');
		},
	},
	methods: {
		...mapActions([actionTypes.setArticleByCode]),
		processInput(event) {
			if (event.keyCode === 13) this.send();
		},
		send() {
			// check if it is a valid code
			if (!this.$store.getters[getterTypes.articleCodeMap][this.code]) {
				errorHandler(new Error(errorTypes.unkownCode));
				return;
			}
			this.setArticleByCode({ code: this.code, closeModal: true });
			this.close();
		},
	},
	mounted() {
		this.code = '';
		this.$refs.keypadInput.focus();
	},
};
</script>
